import { get, requestWithBody } from './fetch';
import { IOrganizationModel } from '../models/Organization';

export const getOrganizations = () => {
  return get({ endpoint: 'api/Organization' });
};

export const getOrganization = (id : number) => {
  return get({ endpoint: `api/Organization/${id}` });
};

export const updateOrganization = (organization : IOrganizationModel, parentId : number | null) => {
  return requestWithBody({ endpoint: `api/Organization/${organization.id}`, body: { ...organization, parentId } }, 'PATCH');
};

export const createOrganization = (organization : IOrganizationModel, parentId : number | null) => {
  return requestWithBody({ endpoint: 'api/Organization', body: { ...organization, parentId }}, 'POST');
};

export const getNotificationChannels = () => {
  return get({ endpoint: 'api/NotificationChannel' });
};